import {VersionMatchHandle} from "@/utils/VersionMatchHandle";
import {closeDialog, showDialog} from "vant";
import {is_mobile, isLandscape} from "@/utils/devices";
import {payCustomer} from "@/api/pay";

export const sendMessage = (data) => {
    window.top.postMessage(data, '*')
}

// 合并参数
export const extend = function (target, options) {
    if (target === undefined || target === null) {
        return options;
    } else {
        if (options) {
            for (const name in options) {
                target[name] = options[name];
            }
        }
        return target;
    }
}

// 登录失效 拉起登录
export const callLogin = () => {
    const defaults = {
        action: "login",
    };
    sendMessage(defaults)
}

// 登录成功
export const loginCallback = (data) => {
    const defaults = {
        action: "loginCallback",
        user_id: '',
        token: '',
    };
    data = extend(defaults, data)
    sendMessage(data)
}

// 支付回调
export const payCallback = (status, cpOrder) => {
    const handleClose = () => {
        closeDialog();
        VersionMatchHandle.sendPayResult(status, cpOrder)
    }
    payCustomer(status).then(({data}) => {
        if(data?.show){
            showDialog({
                className: is_mobile() && isLandscape() ? "land-dialog-pane showDialog-default" : "showDialog-default",
                showConfirmButton:false,
                destroyOnClose: true,
                closeOnClickOverlay: true,
                message: ()=> (
                    <div class="showDialog-default-pane" style={{backgroundImage: `url(${data?.qr_url})`}} onClick={handleClose}></div>
                ),
                beforeClose:()=> {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            VersionMatchHandle.sendPayResult(status, cpOrder)
                        },50)
                        resolve(true);
                    });
                }
            })
        }else{
            VersionMatchHandle.sendPayResult(status, cpOrder)
        }
    }).catch(()=>{
        VersionMatchHandle.sendPayResult(status, cpOrder)
    })

}
// 返回游戏，关闭个人中心弹窗
export const returnGameCallback = () => {
    VersionMatchHandle.closeOpenUrl()
}

export const openUrl = (url) => {
    const defaults = {
        action: "openUrl",
        url: url,
    };
    sendMessage(defaults)
}

//隐藏悬浮球
export function setFloat() {
    VersionMatchHandle.userEditConfig(2, false)
}

//自动登录开关
export function setAutoLogin(status) {
    VersionMatchHandle.userEditConfig(1, status)
}

export function exitPage() {
    if (history.state.back) {
        history.back()
    } else {
        returnGameCallback()
    }
}
// 退出登录
export const callLogout = () => {
    const defaults = {
        action: "logout",
    };
    sendMessage(defaults)
}
